import React, { useState } from "react";
import Header from "../../components/Header";
import PageContainer from "../../components/PageContainer";
import Sidebar from "../../components/Sidebar";
// import DeleteButton from "../../components/actions/DeleteButton";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
//import { deleteService } from "../../services/deleteService";
import toast, { Toaster } from "react-hot-toast";
import ReactTooltip from "react-tooltip";
import FirmFlowTable from "../../components/mytasks/FirmFlowTable";
import { getServiceDepartments } from "../../services/service/getServiceDepartments";
import { deleteDepartment } from "../../services/departments/deleteDepartment";
import DeleteModal from "../../utils/DeleteModal";
import DepartmentBadge from "../../components/deparments/DepartmentBadge";
import DepartmentColorsModal from "../../components/deparments/DepartmentColorsModal";
import { usePermissions } from "../../context/PermissionsContext";

function ServiceDepartments() {
    const { can } = usePermissions();
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    // const [selectedItems, setSelectedItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [serviceDepartments, setServiceDepartments] = useState([]);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isColorsModalOpen, setIsColorsModalOpen] = useState(false);
    const [departmentIdToDelete, setDepartmentIdToDelete] = useState("");
    const [deleteErrorMessage, setDeleteErrorMessage] = useState("");
    const [deleteBlockers, setDeleteBlockers] = useState([]);
    const [isDeletingDepartment, setIsDeletingDepartment] = useState(false);
    const noPermissionMessage = "You don't have permission to do this.";
    const canReadDepartments = can("departments.read");
    const canWriteDepartments = can("departments.write");
    const canDeleteDepartments = can("departments.delete");
    const canManageDepartmentColors = canReadDepartments && canWriteDepartments;

    //Set initial list
    useEffect(() => {
        if (!canReadDepartments) {
            setServiceDepartments([]);
            setLoading(false);
            return;
        }

        getNewServiceDeparments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canReadDepartments]);

    const getNewServiceDeparments = async () => {
        setLoading(true);
        const response = await getServiceDepartments();
        console.log(response);
        if (response.success) {
            setServiceDepartments(response?.data?.departments || []);
        } else {
            // 403 toast is handled globally by axios interceptor.
            if (response?.status !== 403) {
                toast.error(response?.message || "Failed to load departments.");
            }
            setServiceDepartments([]);
        }
        setLoading(false);
    };

    const onHandleClickDeleteDeparment = (departmentId) => {
        if (!canDeleteDepartments) return;
        setDeleteErrorMessage("");
        setDeleteBlockers([]);
        setIsDeleteModalOpen(true);
        setDepartmentIdToDelete(departmentId);
    };

    const setDeleteModalOpen = (isOpen) => {
        setIsDeleteModalOpen(isOpen);
        if (!isOpen) {
            setDeleteErrorMessage("");
            setDeleteBlockers([]);
            setDepartmentIdToDelete("");
        }
    };

    const openColorsModal = () => {
        if (!canManageDepartmentColors) return;
        setIsColorsModalOpen(true);
    };

    const onRemoveDepartment = async () => {
        if (isDeletingDepartment) return;

        setIsDeletingDepartment(true);
        setDeleteErrorMessage("");
        setDeleteBlockers([]);

        try {
            const response = await deleteDepartment(departmentIdToDelete);
            if (response.success) {
                toast.success(response.message);
                setDeleteErrorMessage("");
                setDeleteBlockers([]);
                setDeleteModalOpen(false);
                getNewServiceDeparments();
            } else {
                setDeleteErrorMessage(response.message);
                setDeleteBlockers(response.blockers || []);
            }
        } finally {
            setIsDeletingDepartment(false);
        }
    };

    return (
        <section>
            <Toaster />
            <ReactTooltip
                type="light"
                effect="solid"
                place="top"
                border={true}
                borderColor={"rgb(220,220,220)"}
                className="rounded-md bg-gray-50"
                multiline={false}
            />
            <DeleteModal
                isModalOpen={isDeleteModalOpen}
                setIsModalOpen={setDeleteModalOpen}
                onRemove={onRemoveDepartment}
                errorMessage={deleteErrorMessage}
                blockers={deleteBlockers}
                isDeleting={isDeletingDepartment}
            />
            <DepartmentColorsModal
                departments={serviceDepartments}
                isModalOpen={isColorsModalOpen}
                setIsModalOpen={setIsColorsModalOpen}
                onSaved={getNewServiceDeparments}
            />
            <div className="flex h-screen overflow-hidden">
                {/* Sidebar */}
                <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                {/* Content area */}
                <div className="relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto">
                    {/*  Site header */}
                    <Header
                        sidebarOpen={sidebarOpen}
                        setSidebarOpen={setSidebarOpen}
                    />

                    <PageContainer
                        isLoading={loading}
                        loadingText="Loading service departments..."
                    >
                        <main>
                            <div className="w-full px-4 py-8 mx-auto sm:px-6 lg:px-8 max-w-9xl">
                                {/* Page header */}
                                <div className="mb-8 sm:flex sm:justify-between sm:items-center">
                                    {/* Left: Title */}
                                    <div className="mb-4 sm:mb-0">
                                        <h1 className="text-2xl font-bold md:text-3xl text-slate-800">
                                            Service Departments
                                        </h1>
                                    </div>

                                    {/* Right: Actions */}
                                    <div className="grid items-end justify-start grid-flow-col gap-2 sm:auto-cols-max sm:justify-end">
                                        <span
                                            data-tip={
                                                canManageDepartmentColors
                                                    ? "Manage department colors"
                                                    : noPermissionMessage
                                            }
                                            className="inline-flex"
                                        >
                                            <button
                                                onClick={openColorsModal}
                                                disabled={!canManageDepartmentColors}
                                                className={`h-10 text-white bg-teal-500 btn ${
                                                    canManageDepartmentColors
                                                        ? "hover:bg-teal-600"
                                                        : "opacity-50 cursor-not-allowed"
                                                }`}
                                            >
                                                Manage Department Colors
                                            </button>
                                        </span>

                                        {/* Add service button */}
                                        <span
                                            data-tip={
                                                canWriteDepartments
                                                    ? "Add Department"
                                                    : noPermissionMessage
                                            }
                                            className="inline-flex"
                                        >
                                            <button
                                                onClick={() =>
                                                    navigate("/departments/create")
                                                }
                                                disabled={!canWriteDepartments}
                                                className={`h-10 text-white bg-teal-500 btn ${
                                                    canWriteDepartments
                                                        ? "hover:bg-teal-600"
                                                        : "opacity-50 cursor-not-allowed"
                                                }`}
                                            >
                                                <svg
                                                    className="w-4 h-4 opacity-50 fill-current shrink-0"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                </svg>
                                                <span className="ml-2 xs:block">
                                                    Add Department
                                                </span>
                                            </button>
                                        </span>

                                        {/* Clone button */}
                                        {/* <button onClick={() => clone()} className="h-10 text-white bg-teal-500 btn hover:bg-teal-600">
                      <svg className="w-4 h-4 opacity-50 fill-current shrink-0" viewBox="0 0 16 16">
                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                      </svg>
                      <span className="ml-2 xs:block">Clone Service Template</span>
                    </button> */}
                                    </div>
                                </div>

                                {canReadDepartments ? (
                                    <FirmFlowTable
                                        columns={[
                                            {
                                                Header: "Name",
                                                accessor: "name",
                                                Cell: (props) => (
                                                    <a
                                                        href={`/templates/servicesByDepartment/${props.value}`}
                                                        className="text-gray hover:text-blue-500 rounded-ful"
                                                    >
                                                        <DepartmentBadge
                                                            name={props.value}
                                                            colorHex={
                                                                props.row.original
                                                                    .colorHex
                                                            }
                                                        />
                                                    </a>
                                                ),
                                            },
                                            {
                                                Header: "Actions",
                                                accessor: "id",
                                                Cell: (props) => (
                                                    <>
                                                        <span
                                                            data-tip={
                                                                canWriteDepartments
                                                                    ? "Edit"
                                                                    : noPermissionMessage
                                                            }
                                                            className="inline-flex"
                                                        >
                                                            <button
                                                                onClick={() =>
                                                                    navigate(
                                                                        `/departments/${props.value}`,
                                                                    )
                                                                }
                                                                disabled={
                                                                    !canWriteDepartments
                                                                }
                                                                className={`w-20 h-10 mx-2 text-white bg-teal-500 btn ${
                                                                    canWriteDepartments
                                                                        ? "hover:bg-teal-600"
                                                                        : "opacity-50 cursor-not-allowed"
                                                                }`}
                                                            >
                                                                Edit
                                                            </button>
                                                        </span>

                                                        <span
                                                            data-tip={
                                                                canDeleteDepartments
                                                                    ? "Delete"
                                                                    : noPermissionMessage
                                                            }
                                                            className="inline-flex"
                                                        >
                                                            <button
                                                                onClick={() =>
                                                                    onHandleClickDeleteDeparment(
                                                                        props.value,
                                                                    )
                                                                }
                                                                disabled={
                                                                    !canDeleteDepartments
                                                                }
                                                                className={`w-20 h-10 mx-2 text-white bg-red-500 btn ${
                                                                    canDeleteDepartments
                                                                        ? "hover:bg-red-600"
                                                                        : "opacity-50 cursor-not-allowed"
                                                                }`}
                                                            >
                                                                Delete
                                                            </button>
                                                        </span>
                                                    </>
                                                ),
                                            },
                                        ]}
                                        data={serviceDepartments}
                                    />
                                ) : (
                                    <div className="p-4 text-sm border rounded-sm border-slate-200 text-slate-600">
                                        You don't have permission to view
                                        departments.
                                    </div>
                                )}
                            </div>
                        </main>
                    </PageContainer>
                </div>
            </div>
        </section>
    );
}
export default ServiceDepartments;
